/* eslint-disable react/no-children-prop */
import * as React from 'react';
import { styled } from '@glitz/react';
import TabHeader, { tabComponentId } from './TabHeader';
import { createMaxSmallViewportDecorator } from 'webapp/viewport';
import { getComponentState } from '@avensia/excite';
import { desktopEdgeMarginDecorator, maxContentNormalWidthDecorator } from 'webapp/components/page-layout';

export type HeaderType = {
  headerText: string;
  disabled?: boolean;
};

type TabsProps = {
  tabHeaders: string[];
  children: React.ReactNode;
};

const TabsContainer = styled.div();

const Headers = styled.div(
  maxContentNormalWidthDecorator,
  desktopEdgeMarginDecorator,
  {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: t => t.sharedSpacing.xs,
  },
  createMaxSmallViewportDecorator({
    justifyContent: 'flex-start',
    overflowY: 'auto',
    padding: { x: t => t.sharedSpacing.xs },
  }),
);

export const Tabs = (props: TabsProps) => {
  const [currentTab, setCurrentTab] = React.useState(getComponentState<number>(tabComponentId, 0));
  const { tabHeaders, children } = props;

  return (
    <TabsContainer>
      <Headers>
        {tabHeaders.map((tabHeader, index) => (
          <TabHeader
            key={tabHeader + index}
            isActive={currentTab === index}
            index={index}
            onSelectedTabChanged={setCurrentTab}
          >
            {tabHeader}
          </TabHeader>
        ))}
      </Headers>
      <ActiveTabContent children={children} currentTab={currentTab} />
    </TabsContainer>
  );
};

type ActiveTabPropType = {
  children: React.ReactNode;
  currentTab: number;
};

const ActiveTab = styled.div();

export function ActiveTabContent({ children, currentTab }: ActiveTabPropType) {
  const activeTabContent = React.Children.toArray(children)
    .filter(Boolean)
    .find((value, index) => index === currentTab);
  return <ActiveTab>{activeTabContent}</ActiveTab>;
}
